import React, { useState,useEffect } from "react";
import ReusableModal from "../../../../components/Modals/ReusableModal";
import { useGetCareProgramMutation, useUpdatePatientMutation } from "../../../../features/patient/patientApiSlice";
import { useSelector } from "react-redux";
import { selectUser } from "../../../../features/auth/authSlice";
import { useCreateLogsMutation } from "../../../../features/logs/logsApiSlice";
import {
  ACTIVITY_STATUS,
  ACTIVITY_TYPE,
  // languages,
  programs,
} from "../../../../constants/config.constants";
import languages from '../../../../constants/languages.json'
import StateManagedSelect from "react-select";

const PatientUpdateModal = ({
  open,
  setOpen,
  setData,
  data,
  referralSource,

}) => {
  const user = useSelector(selectUser);
  const [patient, setPatient] = useState(data);
  const [carePrograms, setCarePrograms] = React.useState([]);

  const [updatePatient, { isLoading: updatePatientLoading }] =
    useUpdatePatientMutation();
  const [createLog] = useCreateLogsMutation();
  const [getCarePrograms] = useGetCareProgramMutation();

  const languageOptions = languages
    .sort((a, b) => a.english.localeCompare(b.english))
    .map((language) => ({
      value: language.english,
      label: language.english,
      iso: language.iso639_2b, // Optional: Keep if needed
    }));

  const handleChange = (e) => {
    setPatient({ ...patient, [e.target.name]: e.target.value });
  };

  const handleUpdatePatient = async () => {
    const payload = {
      activity: `Patient (${patient.name}) updated by User ${user?.details?.name}`,
      type: ACTIVITY_TYPE.PATIENT_UPDATE,
      data: {
        patientId: patient.id,
      },
    };
    try {
      const { data } = await updatePatient({
        ...patient,
        patientId: patient.id,
      }).unwrap();
      setData((prev) => ({ ...prev, ...data }));
      await createLog({
        ...payload,
        status: ACTIVITY_STATUS.SUCCESS,
      }).unwrap();
    } catch (error) {
      console.error(error?.data?.message);
      await createLog({
        ...payload,
        status: ACTIVITY_STATUS.FAILED,
      }).unwrap();
    }
  };
const getCareProgram = async () =>{
  try{
     const result = await getCarePrograms(user.organisation.id)?.unwrap();
     setCarePrograms(result?.data);
  }catch(err){
    console.log(err)
  }
}

  useEffect(() =>{
    if(open === "care_program"){
      getCareProgram();
    }
  },[])

  return (
    <ReusableModal
      open={!!open}
      title={
        open === "risk_level" ? "Edit Risk Level" : "Edit patient preference"
      }
      onClose={() => {
        setOpen(false);
      }}
    >
      <div className="flex flex-col items-center min-w-[480px]">
        <div className="h-[1px] w-full bg-primarygrayborder" />
        <div className="flex flex-col w-full gap-4 p-6 overflow-auto max-h-[calc(100vh-200px)]">
          {open === "language" && (
            <div className="flex flex-col gap-2">
              <label
                htmlFor="languagePreference"
                className="m-0 text-base font-semibold"
              >
                Primary Language Preference
              </label>
              <StateManagedSelect
                id="languagePreference"
                name="languagePreference"
                options={languageOptions}
                value={languageOptions.find(
                  (option) => option.value === patient.languagePreference
                )}
                onChange={(selectedOption) =>
                  handleChange({
                    target: {
                      name: "languagePreference",
                      value: selectedOption?.value || "",
                    },
                  })
                }
                placeholder="Select Primary Language Preference"
                isSearchable
                isClearable
                className="w-full border-[1px] border-primarygray rounded-md outline-none"
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />
              {/* <select
                id="languagePreference"
                name="languagePreference"
                value={patient.languagePreference}
                onChange={handleChange}
                className="w-full p-2 border-[1px] border-primarygray rounded-md outline-none"
              >
                {languages.map((language) => (
                  <option value={language.english} key={language.iso639_2b}>
                    {language.english}
                  </option>
                ))}
              </select> */}
            </div>
          )}
          {open === "language" && (
            <div className="flex flex-col gap-2">
              <label
                htmlFor="languagePreference"
                className="m-0 text-base font-semibold"
              >
                Secondary Language Preference
              </label>
              <StateManagedSelect
                options={languages.map((language) => ({
                  label: language.english,
                  value: language.english,
                }))}
                value={
                  patient.secondaryLanguagePreference
                    ? patient.secondaryLanguagePreference
                        .split(",")
                        .map((language) => ({
                          label: language,
                          value: language,
                        }))
                    : null
                }
                onChange={(e) => {
                  setPatient({
                    ...patient,
                    secondaryLanguagePreference: e
                      .map((language) => language.value)
                      .join(","),
                  });
                }}
                placeholder="Select Secondary Language Preference"
                isMulti
                isSearchable
                isClearable
                className="w-full border-[1px] border-primarygray rounded-md outline-none"
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
              />
            </div>
          )}
          {open === "gender" && (
            <div className="flex flex-col gap-2">
              <label
                htmlFor="secondaryphone"
                className="m-0 text-base font-semibold"
              >
                Provider Gender Preference
              </label>
              <select
                id="genderPreference"
                name="genderPreference"
                value={patient.genderPreference}
                onChange={handleChange}
                className="w-full p-2 border-[1px] border-primarygray rounded-md outline-none"
              >
                <option value={""}>Any</option>
                <option value={"M"}>Male</option>
                <option value={"F"}>Female</option>
              </select>
            </div>
          )}
          {open === "referral_source" && (
            <div className="flex flex-col gap-2">
              <label
                htmlFor="referralsource"
                className="m-0 text-base font-semibold"
              >
                Referral Source
              </label>
              <StateManagedSelect
                id="referralsource"
                name="referral_source_id"
                options={referralSource.map((r) => ({
                  label: r.name,
                  value: r.id,
                }))}
                value={
                  referralSource
                    .map((r) => ({ label: r.name, value: r.id }))
                    .find(
                      (option) => option.value === patient.referral_source_id
                    ) || null
                }
                onChange={(selectedOption) =>
                  handleChange({
                    target: {
                      name: "referral_source_id",
                      value: selectedOption ? selectedOption.value : "",
                    },
                  })
                }
                placeholder="Select Referral Source"
                isSearchable
                isClearable
                className="w-full border-[1px] border-primarygray rounded-md outline-none"
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />
            </div>
          )}
          {open === "care_program" && (
            <div className="flex flex-col gap-2">
              <label
                htmlFor="care_program"
                className="m-0 text-base font-semibold"
              >
                Care Program
              </label>
              <StateManagedSelect
                options={carePrograms.map((cp) => ({
                  label: cp.value,
                  value: cp.id, // 👈 ID here
                }))}
                value={
                  patient?.care_programs?.length
                    ? carePrograms
                        .filter((cp) =>
                          patient.care_programs.some((p) => p.id === cp.id)
                        )
                        .map((cp) => ({
                          label: cp.value,
                          value: cp.id,
                        }))
                    : []
                }
                onChange={(selected) => {
                  setPatient({
                    ...patient,
                    care_programs:selected?.map((i) => ({id:i?.value,abbreviation:i?.label})),
                    care_program_ids: selected.map((item) => item.value), // 👈 store IDs
                  });
                }}
                placeholder="Select Care Program"
                isMulti
                isSearchable
                isClearable
                className="w-full border-[1px] border-primarygray rounded-md outline-none"
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
              />
            </div>
          )}
          {open === "text_consent" && (
            <div className="flex flex-col gap-2">
              <label
                htmlFor="text_consent"
                className="m-0 text-base font-semibold"
              >
                Text Consent
              </label>
              <select
                id="text_consent"
                name="text_consent"
                value={patient.text_consent}
                onChange={handleChange}
                className="w-full p-2 border-[1px] border-primarygray rounded-md outline-none"
              >
                <option value={""}>Select Text Consent</option>
                <option value={true}>Yes</option>
                <option value={false}>No</option>
              </select>
            </div>
          )}
          {open === "email_consent" && (
            <div className="flex flex-col gap-2">
              <label
                htmlFor="email_consent"
                className="m-0 text-base font-semibold"
              >
                Email Consent
              </label>
              <select
                id="email_consent"
                name="email_consent"
                value={patient.email_consent}
                onChange={handleChange}
                className="w-full p-2 border-[1px] border-primarygray rounded-md outline-none"
              >
                <option value={""}>Select Email Consent</option>
                <option value={true}>Yes</option>
                <option value={false}>No</option>
              </select>
            </div>
          )}
          {open === "risk_level" && (
            <div className="flex flex-col gap-2">
              <div className="flex flex-col gap-2">
                <label
                  htmlFor="risk_level"
                  className="m-0 text-base font-semibold"
                >
                  Risk level
                </label>
                <input
                  type="text"
                  id="risk_level"
                  name="risk_level"
                  value={patient?.risk_level}
                  onChange={handleChange}
                  className="w-full p-2 border-[1px] border-primarygray rounded-md outline-none"
                  disabled
                />
              </div>
              <div className="flex flex-col gap-2">
                <label
                  htmlFor="risk_pool_indicator"
                  className="m-0 text-base font-semibold"
                >
                  Risk pool indicator
                </label>
                <input
                  type="text"
                  id="risk_pool_indicator"
                  name="risk_pool_indicator"
                  value={patient?.risk_pool_indicator}
                  onChange={handleChange}
                  className="w-full p-2 border-[1px] border-primarygray rounded-md outline-none"
                  disabled
                />
              </div>
            </div>
          )}
        </div>
        <div className="justify-end px-3 mb-2 w-full d-flex">
          <button
            disabled={
              !patient.languagePreference &&
              !patient.genderPreference &&
              !patient.referral_source_id &&
              !patient.care_programs &&
              !patient.text_consent &&
              !patient.email_consent &&
              !patient.risk_level &&
              !patient.risk_pool_indicator
            }
            className="w-[120px]  disabled:opacity-40 disabled:cursor-not-allowed font-semibold p-1 border-[2px] rounded-md bg-subtleblue border-primaryblue text-primaryblue whitespace-nowrap"
            onClick={async () => {
              await handleUpdatePatient();
              setOpen(false);
            }}
          >
            {updatePatientLoading ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </ReusableModal>
  );
};

export default PatientUpdateModal;
